<template>
  <div v-if="items.length !== 0">
    <section class="coming-webinars">
      <div class="container">
        <div class="section-title-header">
          <h2 class="main-title">{{ title }}</h2>
          <div class="coming-webinars__link-wrap" v-if="linkToAll">
            <a :href="`/${lang}/webinars/`" class="link-arrow">{{ translateMap.all[lang] }}</a>
          </div>
        </div>
        <ul class="coming-webinars__list">
          <webinar-global-card
            v-for="item in items"
            :key="item.id"
            :title="item.title"
            :description="item.description"
            :dateExpire="getDate(item.dateExpire)"
            :time="item.time"
            :filePath="item.filePath"
            :lang="lang"
            :coming="new Date(item.dateExpire) < new Date(getTimeCET())"
            :badge="item.badge"
            :soon="item.soon"
          ></webinar-global-card>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import WebinarGlobalCard from "./cards/WebinarGlobalCard";

const translateMap = {
  all: {
    en: 'All webinars',
    de: 'Alle Webinare'
  }
}

export default {
  name: 'WebinarsListGlobal',
  components: {
    WebinarGlobalCard
  },
  props: {
    coming: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    linkToAll: Boolean
  },
  data() {
    return {
      items: [],
      lang: '',
      translateMap
    }
  },
  mounted() {
    this.lang = this.getCurrentLang();
    this.getWebinars();
  },
  methods: {
    getWebinars() {
      fetch(`/${this.lang}/webinars/index.json`)
        .then((response) => response.json())
        .then((data) => {
          const webinars = data.data.filter((w) => !w.donotshow);
          if(this.coming) {
            this.items = webinars.filter((w) => new Date(w.dateExpire) > new Date(this.getTimeCET())).sort((a, b) => b.id - a.id);
          } else {
            this.items = webinars.filter((w) => new Date(w.dateExpire) < new Date(this.getTimeCET())).sort((a, b) => b.id - a.id);
          }
        });
    },
    getTimeCET() {
      let time = new Date().toLocaleDateString('ru-Ru',{
        timeZone: 'CET',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false })
      // преобразование даты -> 17.04.2022, 12:47:12 => 2022-04-17T12:59:05Z
      return time.replace(/(\d+)\.(\d+)\.(\d+),\s(\d+)\:(\d+)\:(\d+)/, '$3-$2-$1T$4:$5:$6') + 'Z'
    },
    getCurrentLang() {
      return window.location.pathname.split('/').filter((i) => i !== '')[0];
    },
    getDate(date) {
      const datetime = new Date(date);
      return datetime.toLocaleDateString('en-EN', {month: 'short', day: '2-digit', year: 'numeric'});
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/WebinarsListGlobal.vue